
<v-footer
    height="auto"
    color="primary"
    class="footer"
>
  <v-row justify="center" align="center" wrap>
    <v-col cols="12" md="3">
      <v-row justify="center" class="links">
        <v-btn
            text
            to="/imprint"
        >
          {{ $t("IMPRINT_LINK") }}
        </v-btn>
        <v-btn
            text
            to="/privacy"
        >
          {{ $t("PRIVACY_LINK") }}
        </v-btn>
        <v-btn
            text
            to="/tos"
        >
          {{ $t("TERMS_CONDITIONS_SHORTNAME") }}
        </v-btn>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" md="6" class="paymentMethods">
      <div class="paymentText">
        <div v-if="paymentMethodActive('KLARNA_LATER')">
          <v-icon>check_circle_outline</v-icon>
          <span>{{ $t('FOOTER_PAY_PER_BILL') }}</span>
        </div>
        <div v-if="paymentMethodActive('BANK_TRANSFER')">
          <v-icon>check_circle_outline</v-icon>
          <span>{{ $t('FOOTER_PAY_PER_BANK_TRANSFER') }}</span>
        </div>
        <div v-if="paymentMethodActive('CASH_ENVELOPE')">
          <v-icon>check_circle_outline</v-icon>
          <span>{{ $t('FOOTER_PAY_PER_CASH_ENVELOPE') }}</span>
        </div>
      </div>
      <div class="icons">
        <img v-if="paymentMethodActive('KLARNA_NOW')" src="@/assets/payment/klarna.svg" class="paymentIcon">
        <img v-if="paymentMethodActive('SOFORT')" src="@/assets/payment/sofort.svg" class="paymentIcon sofort">
        <img v-if="paymentMethodActive('CREDIT_CARD')" src="@/assets/payment/visa.svg" class="paymentIcon visa">
        <img v-if="paymentMethodActive('CREDIT_CARD')" src="@/assets/payment/mastercard.svg" class="paymentIcon">
        <img v-if="paymentMethodActive('CREDIT_CARD')" src="@/assets/payment/amex.svg" class="paymentIcon">
        <v-icon v-if="paymentMethodActive('BANK_TRANSFER')" class="paymentIcon" size="30px">account_balance</v-icon>
        <v-icon v-if="paymentMethodActive('CASH_ENVELOPE')" class="paymentIcon" size="30px">mail</v-icon>
      </div>
    </v-col>
    <v-col
        primary
        py-3
        text-xs-center
        white--text
        cols="12" md="3"
    >
      <div class="copyright" v-html="$t('FOOTER_COPYRIGHT_NOTICE')"></div>
      <HelpBubble/>
    </v-col>
  </v-row>
</v-footer>

